import { Account,  } from 'models/app';

export const getAccountFromStorage = (): Maybe<Account> => {
  const account = sessionStorage.getItem('account');

  return account ? JSON.parse(account) : undefined;
};

export const getMerchantIdFromStorage = (): Uuid => {
  const merchantId = sessionStorage.getItem('merchantId');

  return merchantId || '';
};
